module.exports = __webpack_public_path__ + "static/media/000006.3be48813.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/000006.mp3
// module id = 746
// module chunks = 0